import { Component, OnInit, OnDestroy, ViewChild, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { AppMenuComponent } from '../app-menu/app-menu.component';
import { MenuItem } from 'primeng/api';
import { MenuModule } from 'primeng/menu';
import { DividerModule } from 'primeng/divider';
import { LoginService } from '../../../app/service/auth-service/login.service';
import { ModuleService } from '../../../app/service/module-service/module.service';
import { User } from '../../interface';
import { Subject, takeUntil } from 'rxjs';
import { CommonModule } from '@angular/common';
import { UserAvatarComponent } from '@app/pages/shared/user-avatar/user-avatar.component';
import { TemplateService } from '@app/service/template-service/template.service';


@Component({
  selector: 'app-sidebar',
  imports: [CommonModule, AppMenuComponent, MenuModule, DividerModule, UserAvatarComponent],
  templateUrl: './app-sidebar.component.html',
  styleUrl: './app-sidebar.component.scss',
})
export class AppSidebarComponent implements OnInit, OnDestroy {
  @ViewChild('menu') menu: any;
  currentUser: User | null = null;
  bottomMenuItems: MenuItem[] = [];
  private destroy$ = new Subject<void>();

  constructor(
    private loginService: LoginService,
    private router: Router,
    private moduleService: ModuleService,
    private templateService: TemplateService
  ) {}

  ngOnInit() {
    this.templateService.fetchTemplates();
    this.loginService.authUser$
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User | null) => {
        this.currentUser = user;
        this.updateBottomMenuItems();
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateBottomMenuItems() {
    this.bottomMenuItems = [
      { label: 'Profile', icon: 'pi pi-user', command: () => this.profile() },
      { label: 'Logout', icon: 'pi pi-sign-out', command: () => this.logout() },
    ];
  }

  profile() {
    this.router.navigate(['/profile']);
  }

  logout() {
    this.loginService.logout().subscribe({
      next: () => {
        this.router.navigate(['/auth/login']);
      },
      error: () => {
        this.loginService.clearTokens();
        this.router.navigate(['/auth/login']);
      }
    });
  }

  /**
   * Hide menu on scroll
   */
  @HostListener('window:scroll')
  onScroll() {
    if (this.menu && this.menu.visible) {
      this.menu.hide();
    }
  }

  /**
   * Hide menu on wheel event (for better scroll detection)
   */
  @HostListener('window:wheel')
  onWheel() {
    if (this.menu && this.menu.visible) {
      this.menu.hide();
    }
  }
}
